module.exports = __webpack_public_path__ + "img/gl-logo.fb934c68.png";